module.exports = __webpack_public_path__ + "img/overview-private.d8cfba3c.png";